var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{on:{"click":_vm.match}},[_vm._v("快速开始")]),_c('button',{on:{"click":_vm.create}},[_vm._v("创建新游戏")])])}
var staticRenderFns = []

export { render, staticRenderFns }